import { render, staticRenderFns } from "./CheckboxGroup.vue?vue&type=template&id=8ceaf5f2&"
import script from "./CheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./CheckboxGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports